import { getByDcUuidAndArticleUuid, save, modify, removeArticleAttachment  } from '@/services/internal/article/ArticleAttachment';

export default {
  namespace: 'articleAttachment',

  state: {
    entity: '',
    articleBusiness:{},
    list: []
  },

  effects: {
    *getByDcUuidAndArticleUuid({ payload, callback }, { call, put }) {
      const response = yield call(getByDcUuidAndArticleUuid, payload);
      yield put({
        type: 'saveForSelect',
        payload: response.data
      })
      if (callback) callback(response);
    },

    *save({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (callback) callback(response);
    },

    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (callback) callback(response);
    },

    *removeArticleAttachment({ payload, callback }, { call, put }) {
      const response = yield call(removeArticleAttachment, payload);
      if (callback) callback(response);
    },

  },

  reducers: {
    saveForSelect(state, action) {
      return {
        ...state,
        listForSelect: action.payload,
      };
    },
  }
}
